<template>
  <div id="mainnavigation">
    <div class="upper">
      <h1>
        <span>総合葬祭式場</span>
        <img src="@/assets/images/logo01.svg" alt="天聖閣" />
      </h1>
      <div class="saijo">
        <ul>
          <li>本渡斎場</li>
          <li>五和斎場</li>
          <li>苓北斎場</li>
        </ul>
        <p>天草内に3会館。天草での御葬儀はお任せください</p>
      </div>
    </div>
    <nav>
      <router-link class="navitem" to="/">トップページ</router-link>
      <router-link class="navitem" to="/feature">天聖閣の特徴</router-link>
      <router-link class="navitem" to="/plan">御葬儀プラン</router-link>
      <div class="navitem dropdown">
        会館のご案内
        <ul>
          <li>
            <router-link to="/information/hondo">本渡斎場</router-link>
          </li>
          <li>
            <router-link to="/information/itsuwa">五和斎場</router-link>
          </li>
          <li>
            <router-link to="/information/reihoku">苓北斎場</router-link>
          </li>
        </ul>
      </div>
      <router-link class="navitem" to="/contact">お問い合わせ</router-link>
    </nav>
    <div class="tel">
      <div class="flex">
        <h5>
          お急ぎの方
          <span>はお電話ください</span>
        </h5>
        <a href="tel:0969240983">
          <img src="@/assets/images/nav-tel.svg" alt="0969-24-0983" />
        </a>
      </div>
      <p>24時間365日承ります</p>
    </div>
  </div>
  <div id="spnavigation">
    <div class="upper">
      <router-link @click="navState = false" class="navitem" to="/">
        <h1>
          <span>総合葬祭式場</span>
          <img src="@/assets/images/logo01.svg" alt="天聖閣" />
        </h1>
      </router-link>
    </div>
    <div
      id="navigation-btn"
      @click="navState = !navState"
      :class="{ active: navState }"
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
    <nav :class="{ active: navState }">
      <h2>
        <img src="@/assets/images/mainlogo.svg" alt="天聖閣" />
      </h2>
      <router-link @click="navState = false" class="navitem" to="/">
        トップページ
      </router-link>
      <router-link @click="navState = false" class="navitem" to="/feature">
        天聖閣の特徴
      </router-link>
      <router-link @click="navState = false" class="navitem" to="/plan">
        御葬儀プラン
      </router-link>
      <div class="navitem">会館のご案内</div>
      <ul>
        <li>
          <router-link @click="navState = false" to="/information/hondo">
            <img src="@/assets/images/thumb-hondo.jpg" alt="天聖閣本渡斎場" />
            <h3>本渡斎場</h3>
          </router-link>
        </li>
        <li>
          <router-link @click="navState = false" to="/information/itsuwa">
            <img src="@/assets/images/thumb-itsuwa.jpg" alt="天聖閣五和斎場" />
            <h3>五和斎場</h3>
          </router-link>
        </li>
        <li>
          <router-link @click="navState = false" to="/information/reihoku">
            <img src="@/assets/images/thumb-reihoku.jpg" alt="天聖閣苓北斎場" />
            <h3>苓北斎場</h3>
          </router-link>
        </li>
      </ul>
      <router-link @click="navState = false" class="navitem" to="/contact">
        お問い合わせ
      </router-link>
      <a class="oisogi" href="tel:0969240983">
        <h5>お急ぎの方はこちら</h5>
        <p>24時間365日承ります</p>
        <div class="tel">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="32"
            height="32"
            viewBox="0 0 32 32"
          >
            <g>
              <path
                d="M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0m8.58,21.083-2.9,3.449a.771.771,0,0,1-.948.186s-.948-.469-1.671-.9A34.4,34.4,0,0,1,13,19a34.4,34.4,0,0,1-4.821-6.062c-.429-.723-.9-1.671-.9-1.671a.771.771,0,0,1,.186-.948l3.449-2.9a.765.765,0,0,1,1.033.045L14.7,10.217a.769.769,0,0,1,.056,1.022l-1.163,1.434a.781.781,0,0,0,.011.977,19.39,19.39,0,0,0,2.173,2.574A19.818,19.818,0,0,0,18.351,18.4a.781.781,0,0,0,.977.011l1.434-1.163a.769.769,0,0,1,1.022.056l2.749,2.749a.765.765,0,0,1,.045,1.033"
              />
            </g>
          </svg>
          今すぐお電話
        </div>
      </a>
    </nav>
  </div>
  <div id="baloon-tel">
    <div>
      <h5>お急ぎの方はこちら</h5>
      <p>24時間365日承ります</p>
    </div>
    <a href="tel:0969240983">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <g>
          <path
            d="M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0m8.58,21.083-2.9,3.449a.771.771,0,0,1-.948.186s-.948-.469-1.671-.9A34.4,34.4,0,0,1,13,19a34.4,34.4,0,0,1-4.821-6.062c-.429-.723-.9-1.671-.9-1.671a.771.771,0,0,1,.186-.948l3.449-2.9a.765.765,0,0,1,1.033.045L14.7,10.217a.769.769,0,0,1,.056,1.022l-1.163,1.434a.781.781,0,0,0,.011.977,19.39,19.39,0,0,0,2.173,2.574A19.818,19.818,0,0,0,18.351,18.4a.781.781,0,0,0,.977.011l1.434-1.163a.769.769,0,0,1,1.022.056l2.749,2.749a.765.765,0,0,1,.045,1.033"
          />
        </g>
      </svg>
      <span>今すぐお電話</span>
    </a>
  </div>
</template>

<script>
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default {
  data() {
    return {
      navState: false,
    };
  },
  mounted() {
    this.NavigationControl();
  },
  methods: {
    NavigationControl() {
      let target = document.getElementById("mainnavigation");
      ScrollTrigger.create({
        trigger: "body",
        start: "top -10%",
        onEnter: () => {
          target.classList.add("small");
        },
        onLeaveBack: () => {
          target.classList.remove("small");
        },
      });
      let target2 = document.getElementById("baloon-tel");
      ScrollTrigger.create({
        trigger: "body",
        start: "top -10%",
        onEnter: () => {
          target2.classList.add("hidden");
        },
        onLeaveBack: () => {
          target2.classList.remove("hidden");
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#baloon-tel {
  display: none;
  @include tb {
    font-family: $sans-serif;
    font-weight: bold;
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 990;
    background-color: rgba(255, 255, 255, 0.8);
    width: 100%;
    padding: 0.5rem 1rem;
    padding-bottom: 1.5rem;
    transition: 0.2s;

    &.hidden {
      height: 0px;
      padding: 0;
      & > div {
        display: none;
      }
      a {
        background-color: white;
        position: absolute;
        bottom: 0;
        right: 0;
        margin-right: 1rem;
        margin-bottom: 1.5rem;
        padding: 0;
        height: 60px;
        width: 140px;
        min-width: 0;
        border-radius: 30px;
        flex-direction: row-reverse;
        gap: 0;
        filter: drop-shadow(2px 2px 10px rgba(0, 0, 0, 0.2));
        span {
          color: $blue;
          font-size: 0.65rem;
          display: block;
          text-align: center;
          flex-grow: 1;
          padding: 0 0.5em;
        }
        svg {
          margin-right: 4px;
          margin-left: auto;
          width: 52px;
          height: 52px;
          fill: $blue;
        }
      }
    }
    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      p {
        font-size: 0.75rem;
      }
    }
    a {
      background-color: $blue;
      color: white;
      height: 3.5rem;
      border-radius: 0.25rem;
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0 1rem;
      width: 40vw;
      min-width: 160px;
      margin-left: auto;
      gap: 0.5rem;
      transition: 0.2s;
      white-space: pre;
      svg {
        fill: white;
      }
    }
  }
}
#spnavigation {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: white;
  height: 80px;
  width: 100%;

  @include tb {
    display: block;
  }
  nav {
    background: linear-gradient(rgb(7, 33, 80), rgba(39, 84, 142, 0.95));
    position: fixed;
    left: 0;
    top: 0;
    transition: 0.2s;
    width: 100%;
    padding: 1rem 1rem 2rem 1rem;
    color: white;
    transform: translateY(-100%);
    height: 100vh;
    z-index: 1;
    overflow: hidden;
    &.active {
      transform: none;
    }
    h2 {
      margin: 0 auto;
      text-align: center;
      margin-bottom: 1rem;
      span {
        display: block;
        font-size: 0.65rem;
        text-align: center;
        margin-bottom: 0.5em;
      }
      img {
        max-width: 30vw;
        max-height: 5rem;
        width: auto;
        transition: 0.5s;
      }
    }
    .navitem {
      text-align: center;
      width: 100%;
      display: block;
      border-top: 1px solid #ccc;
      font-size: 1.25rem;
      padding: 1rem 2rem;
      background: linear-gradient(#fff, #eee);
      background-image: url(@/assets/images/dots.svg);
      background-position: 0.5em center;
      background-repeat: no-repeat;
      &:first-child {
        border-top: none;
      }
      &:last-child {
        border-bottom: 1px solid #ccc;
      }
    }
    ul {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      font-size: 1.25rem;

      margin-bottom: 1rem;
      grid-gap: 0.5rem;
      li {
        @include dogear(0.5rem);
        text-align: center;
        font-size: 1rem;
        &:nth-child(1) {
          background-color: $color-hondo;
        }

        &:nth-child(2) {
          background-color: $color-itsuwa;
        }

        &:nth-child(3) {
          background-color: $color-reihoku;
        }
        h3 {
          padding: 0.5rem 1rem;
        }
        img {
          aspect-ratio: 21/9;
          object-fit: cover;
        }
      }
    }
    .oisogi {
      font-family: $sans-serif;
      font-weight: 600;
      display: block;
      text-align: center;
      background-color: $color-hondo;
      border-radius: 0.5rem;
      padding: 1rem 0.5rem 0.5rem 0.5rem;
      max-width: 360px;
      margin: 0 auto;
      margin-top: 1rem;
      h5 {
        font-size: 1.5rem;
      }
      border-bottom: 4px solid darkolivegreen;
      .tel {
        margin-top: 0.5rem;
        font-size: 1.25rem;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
      }
      svg {
        fill: white;
      }
    }
  }
  #navigation-btn {
    font-family: $sans-serif;
    font-weight: bold;
    border: 1px solid $blue;
    border-radius: 4px;
    margin: 1rem;
    color: $blue;
    background-color: white;
    height: 56px;
    width: 56px;
    position: fixed;
    z-index: 999;
    display: block;
    right: 0;
    top: 0;
    &::after {
      content: "メニュー";
      text-align: center;
      display: block;
      position: absolute;
      bottom: 6px;
      left: 0;
      width: 100%;
      font-size: 0.65rem;
    }
    span {
      display: block;
      background-color: $blue;
      width: 36px;
      height: 3px;
      position: absolute;
      transition: 0.2s;
      left: 9px;
      &:nth-child(1) {
        top: 10px;
      }
      &:nth-child(2) {
        top: 20px;
      }
      &:nth-child(3) {
        top: 30px;
      }
    }
    &.active {
      &::after {
        content: "閉じる";
      }
      span {
        top: 20px;
        &:nth-child(1) {
          transform: rotate(30deg) scaleX(1);
        }
        &:nth-child(2) {
          transform: rotate(-30deg) scaleX(1);
        }
        &:nth-child(3) {
          transform: scaleX(0);
        }
      }
    }
  }
  .upper {
    border-top: 0.5rem solid $blue;
    background: linear-gradient(#fff, #eee);
    position: relative;
    border-bottom: 1px solid $color-lgray;
    display: flex;
    padding: 0.5rem 1rem;
    align-items: center;
    gap: 1rem;
    height: 100%;
    z-index: 0;
    h1 {
      span {
        display: block;
        font-size: 0.65rem;
        text-align: center;
        margin-bottom: 0.5em;
      }
      img {
        max-height: 2.5rem;
        width: auto;
        transition: 0.5s;
      }
    }
    .saijo {
      transition: opacity 0.5s;
      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0.25rem;
        margin-bottom: 0.25rem;
        li {
          text-align: center;
          position: relative;
          background-color: $color-hondo;
          padding: 0.35em 1em;
          color: white;
          z-index: 0;
          &::before {
            height: 0;
            display: block;
            position: absolute;
            left: 0px;
            content: "";
            border-top: solid 10px #fff;
            border-right: solid 10px transparent;
            top: 0px;
            z-index: 1;
          }
          &:nth-child(2) {
            background-color: $color-itsuwa;
          }

          &:nth-child(3) {
            background-color: $color-reihoku;
          }
        }
      }
      p {
        font-size: 0.875rem;
      }
    }
  }
}
#mainnavigation {
  border-top: 0.5rem solid $blue;
  position: relative;
  width: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: white;
  transition: 0.5s;

  @include tb {
    display: none;
  }

  .upper {
    border-bottom: 1px solid $color-lgray;
    display: flex;
    padding: 1rem $h-gap;
    align-items: center;
    gap: 1rem;
    @include tb {
      height: 80px;
    }
    h1 {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      span {
        display: inline-block;
        font-size: 0.875rem;
        margin-right: 1rem;
      }
      img {
        max-height: 3.5rem;
        width: auto;
        transition: 0.5s;
      }
    }
    .saijo {
      transition: opacity 0.5s;
      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0.25rem;
        margin-bottom: 0.25rem;
        li {
          text-align: center;
          position: relative;
          background-color: $color-hondo;
          padding: 0.35em 1em;
          color: white;
          z-index: 0;
          &::before {
            height: 0;
            display: block;
            position: absolute;
            left: 0px;
            content: "";
            border-top: solid 10px #fff;
            border-right: solid 10px transparent;
            top: 0px;
            z-index: 1;
          }
          &:nth-child(2) {
            background-color: $color-itsuwa;
          }

          &:nth-child(3) {
            background-color: $color-reihoku;
          }
        }
      }
      p {
        font-size: 0.875rem;
      }
    }
  }

  nav {
    padding: 0 $h-gap;
    background: linear-gradient(#eee, #fff);
    left: 0;
    @include tb {
      position: absolute;
      left: 100%;
      &.active {
        left: 0;
      }
    }
    .navitem {
      background: linear-gradient(#fff, #eee);
      background-image: url(@/assets/images/dots.svg);
      background-position: 0.5em center;
      background-repeat: no-repeat;
      display: inline-block;
      height: 3rem;
      line-height: 3rem;
      padding-left: clamp(1rem, 1vw, 2rem);
      padding-right: clamp(1rem, 1vw, 2rem);
      text-align: center;
      width: 180px;
      position: relative;
      border-left: 1px solid $color-lgray;
      z-index: 0;
      transition: 0.5s;
      @include pc {
        width: calc(140px + 2vw);
      }
      &:last-child {
        border-right: 1px solid $color-lgray;
      }
      &::after {
        @include pseudo;
        width: 0%;
        height: 4px;
        background-color: $blue;
        left: 0;
        bottom: 0;
        transition: 0.2s;
      }
      &:hover {
        &::after {
          width: 100%;
        }
      }
      &.router-link-exact-active {
        &::after {
          width: 100%;
        }
      }
      &.dropdown {
        z-index: 1;
        &:hover {
          &::after {
            width: 100%;
          }
          ul {
            height: calc(49px * 3);
          }
        }
        ul {
          height: 0;
          overflow: hidden;
          z-index: 1;
          position: absolute;
          width: 100%;
          left: 0;
          top: calc(100% + 0px);
          transition: 0.2s;
          z-index: 9999;
          li {
            background-color: $color-bg1;
            &:hover {
              background-color: white;
            }
            a {
              display: block;
              width: 100%;
              height: 48px;
              border-bottom: 1px solid #ccc;
            }
          }
        }
      }
    }
  }

  .tel {
    position: absolute;
    right: 0;
    top: 0;
    border-bottom-left-radius: 2rem;
    background-color: #4871e2;
    padding: 0.5rem 2rem;
    color: white;
    text-align: center;
    width: 320px;
    transition: 0.5s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include pc {
      width: auto;
      height: 89px;
      padding: 0.5rem 1rem;
      .flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    h5 {
      margin-bottom: 0.5rem;
      transition: 0.5s;
      @include pc {
        display: inline-block;
        font-size: 0.875rem;
        margin-bottom: 0;
        margin-right: 1rem;
      }
      span {
        white-space: pre;
        @include pc {
          display: none;
        }
      }
    }
    a {
      display: block;
      @include pc {
        display: inline-block;
      }
      img {
        transition: 0.5s;
        width: 100%;
        height: auto;
        @include pc {
          max-height: 28px;
        }
      }
    }
    p {
      transition: 0.5s;
      margin-top: 0.5rem;
      padding-top: 0.25rem;
      border-top: 1px solid white;
      font-size: 0.875rem;
      @include pc {
      }
    }
  }
}
#mainnavigation.small:not(:hover) {
  .upper {
    padding: 0.5rem $h-gap;
    h1 {
      span {
        display: inline-block;
        font-size: 0.875rem;
        margin-right: 1rem;
      }
      img {
        max-height: 2rem;
        width: auto;
      }
    }
    .saijo {
      visibility: hidden;
      opacity: 0;
      position: absolute;
    }
  }

  nav {
    .navitem {
      height: 2rem;
      line-height: 2rem;
    }
  }

  .tel {
    height: 49px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: auto;
    .flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    h5 {
      white-space: pre;
      display: inline-block;
      font-size: 0.875rem;
      margin-bottom: 0;
      margin-right: 1rem;
      span {
        display: none;
      }
    }
    a {
      display: inline-block;
      img {
        max-height: 28px;
      }
    }
    p {
      max-width: 90px;
      font-size: 0.875rem;
      line-height: 1;
      border: none;
      padding: 0;
      margin: 0;
    }
  }
}
</style>
